import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

import { createLinkToken } from '../actions/plaid';

function usePlaid() {
  const dispatch = useDispatch();
  const [linkToken, setLinkToken] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const fetchLinkToken = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await dispatch(createLinkToken());
      if (response && response.link_token) {
        setLinkToken(response.link_token);
      } else {
        console.error('Invalid link token response:', response);
      }
    } catch (error) {
      console.error('Failed to fetch link token:', error);
    } finally {
      setIsLoading(false);
    }
  }, [dispatch]);

  return {
    linkToken,
    fetchLinkToken,
    isLoading,
  };
}

export default usePlaid;
